import { LockOpen } from '@phosphor-icons/react';

export default LockOpen;
